import React from "react";
import { Page, Text, Card, Grid, Spacer, useTheme } from "@geist-ui/core";
import { ArrowUpRight, TrendingUp } from "@geist-ui/icons";

export default function DashboardScreenshot() {
  const theme = useTheme();

  const positions = [
    { name: 'Tech Ventures', fund: 'Fonds V', amount: '€ 25.000', return: '+24%', active: true },
    { name: 'Cherry Ventures', fund: 'Fonds IV', amount: '€ 15.000', return: '+12%', active: true },
    { name: 'HV Capital', fund: 'Fonds VIII', amount: '€ 10.000', return: '+8%', active: true },
  ];

  return (
    <div style={{ 
        background: '#fff', 
        minHeight: '100vh', 
        padding: '60px 24px',
        fontFamily: '"Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
        <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@200;300;400;600;700;800;900&display=swap');
        `}</style>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '48px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '8px', height: '8px', background: '#000', borderRadius: '50%' }}></div>
                <Text span style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em' }}>LIVE</Text>
            </div>
            <div style={{ textDecoration: 'underline', fontSize: '12px', fontWeight: 600 }}>Vermögensbericht</div>
        </div>

        {/* Wealth Section - Massive */}
        <div style={{ marginBottom: '60px' }}>
            <Text span style={{ fontSize: '12px', color: '#999', fontWeight: 600, letterSpacing: '0.05em', marginBottom: '12px', display: 'block' }}>GESAMTVERMÖGEN</Text>
            <Text h1 style={{ margin: '0 0 16px 0', fontSize: '56px', fontWeight: 900, letterSpacing: '-0.04em', lineHeight: 0.9, fontFamily: '"Nunito Sans", sans-serif' }}>
                €57.100
            </Text>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#000' }}>
                 <div style={{ background: '#f5f5f5', padding: '4px 8px', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <TrendingUp size={14} color="#000" />
                    <Text span style={{ fontSize: '12px', fontWeight: 700, color: '#000' }}>14.2%</Text>
                 </div>
                 <Text span style={{ fontSize: '12px', color: '#999', fontWeight: 500 }}>Gesamt</Text>
            </div>
        </div>

        {/* Allocation Bar (Abstract Chart) */}
        <div style={{ display: 'flex', width: '100%', height: '4px', gap: '4px', marginBottom: '60px' }}>
            <div style={{ flex: 6, background: '#000', borderRadius: '2px' }}></div>
            <div style={{ flex: 3, background: '#999', borderRadius: '2px' }}></div>
            <div style={{ flex: 1, background: '#eaeaea', borderRadius: '2px' }}></div>
        </div>

        {/* Portfolio List */}
        <div style={{ borderTop: '1px solid #000', paddingTop: '24px' }}>
            <Text h4 style={{ margin: '0 0 32px 0', fontSize: '14px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Ihre Positionen</Text>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                {positions.map((pos, i) => (
                    <div key={i} style={{ 
                        padding: '24px 0', 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        borderBottom: '1px solid #f0f0f0' 
                    }}>
                        <div>
                            <Text p style={{ margin: '0 0 4px 0', fontSize: '16px', fontWeight: 700, filter: 'blur(10px)', userSelect: 'none' }}>{pos.name}</Text>
                            <Text span style={{ fontSize: '11px', color: '#999', fontWeight: 600, letterSpacing: '0.05em' }}>{pos.fund.toUpperCase().replace('FUND', 'FONDS')}</Text>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <Text p style={{ margin: '0 0 4px 0', fontSize: '16px', fontWeight: 700 }}>{pos.amount}</Text>
                            <Text span style={{ fontSize: '12px', color: '#000', fontWeight: 600, background: 'rgba(0,0,0,0.05)', padding: '2px 6px', borderRadius: '4px' }}>{pos.return}</Text>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
  );
}
